import FollowButton from "components/FollowButton";
import { VerifiedIcon } from "components/VerifiedIcon";
import PostVideoItem from "features/posts/postVideoItem";
import LoginModal from "features/user/userModals/LoginModal";
import { useAuth } from "helpers/authContext";
import useModal from "helpers/useModal";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { find_posts, get_plans, get_views } from "services/db-service";
import { getAccounts, getReputation, lookupAccounts } from "services/dsteem-service";
import { processPosts } from "services/posts-service";
import Skeleton from "react-loading-skeleton";

const SearchResults: React.FC = () => {
    const location = useLocation();
    const { toggleLoginModal, isOpenLoginModal } = useModal();
    const { user } = useAuth(); 
    const [activeTab, setActiveTab] = useState("");
    const [accounts, setAccounts] = useState([]);
    const [limit] = useState(30);
    const [currentPosts, setCurrentPosts] = useState([]);
    const [startFrom, setStartFrom] = useState(0); 
    const [userPlans, setUserPlans] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(false); 
    const observer = useRef<IntersectionObserver | null>(null); 
    const params = new URLSearchParams(location.search);
    const [views, setViews] = useState([]);
    const query = params.get("q");
    useEffect(() => {
        const getViews = async () => { 
            let data = await get_views();
            setViews(data); 
        }
        getViews(); 
        const getPlans = async () => { 
            let data = await get_plans(); 
            setUserPlans(data); 
        }
        getPlans(); 
    }, []);
    const lookup = async () => { 
        setLoading(true);
        setAccounts([]);
        try {
            let data = await lookupAccounts(query.toLowerCase(), 10);
            let accountsData = await getAccounts(data);
            setAccounts(accountsData);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }
    const find_content = async () => {
        setLoading(true);
        setCurrentPosts([]);
        console.log("fetching videos");
        // setFilter("videos");
        let video_posts = [];
        try {
            video_posts = (await find_posts(limit, 0, query)) || []; 
            if (video_posts != undefined && video_posts.length > 0) {
                video_posts = processPosts(video_posts); 
                setCurrentPosts(video_posts || []);
                let hasMore = false;
                if (video_posts.length >= limit) {
                    hasMore = true;
                    setStartFrom(limit);
                } 
                setHasMore(hasMore); 
            }
        } catch (error) { 
            console.log(error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => { 
        if (query.includes(" ")) {
            setAccounts([]);
            setActiveTab("video");
            find_content();
        }else {
            setAccounts([]);
            setActiveTab("user");
            lookup();
        }
    }, [query]);
    useEffect(() => { 
        if (activeTab == "video") {
            setAccounts([]); 
            find_content();
        }else {
            lookup();
        }
    }, [activeTab]);


    const loadMorePosts = useCallback(async () => { 
        if (!hasMore || currentPosts.length === 0) return;
        
        setLoadingMore(true); 
        try {
            if (activeTab == "video") {
                console.log("loading more from the db", startFrom);
                let video_posts = [];
                try {
                    video_posts = (await find_posts(limit, 0, query)) || [];  
                } catch (error) {
                    console.log(error);
                } 
                if (video_posts != undefined && video_posts.length > 0) {
                    video_posts = processPosts(video_posts); 
                    const newPosts = video_posts.filter(newPost =>
                        !currentPosts.some(existingPost =>
                        existingPost.author === newPost.author && existingPost.permlink === newPost.permlink
                        )
                    );
                
                    const updatedPosts = [...currentPosts, ...newPosts];
                    setCurrentPosts(updatedPosts || []);
                    let hasMore = false;
                    if (video_posts.length >= limit) {
                        hasMore = true;
                        setStartFrom(updatedPosts.length);
                    } 
                    setHasMore(hasMore); 
                } 
            }
            
        
        } catch (err) {
            console.log('error getting', err); 
        }
        
        setLoadingMore(false);
    }, [limit, currentPosts, hasMore]);
    const lastPostElementRef = useCallback((node) => {  
        if (loadingMore) { return; } 
        if (observer.current) {  
            observer.current.disconnect();
        }
        observer.current = new IntersectionObserver(entries => { 
            if (entries[0].isIntersecting && hasMore) {
            console.log('last element visible, loading more...'); 
            loadMorePosts();
            }
        }, { 
            threshold: 0.1 
        });
        if (node) observer.current.observe(node);
    }, [loadingMore, hasMore, loadMorePosts]); 

    const renderPosts = () => { 
        if (loading && activeTab === "video") {
            return (
                <div className="row w-100 m-0">
                    {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
                        <div key={i} className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 p-2">
                            <div className="card item-speem" style={{border: "none"}}>
                                <Skeleton height={180} className="mb-2" />
                                <div className="p-2">
                                    <div className="d-flex align-items-center mb-2">
                                        <Skeleton circle={true} height={35} width={35} className="mr-2" />
                                        <Skeleton width="60%" height={15} />
                                    </div>
                                    <Skeleton width="90%" height={20} className="mb-1" />
                                    <Skeleton width="40%" height={12} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }
        if(!loading && currentPosts.length == 0 && activeTab == "video"){ 
            return (
                <div className='text-center w-100'><strong>No posts yet.</strong></div>
            )
        }
        let section = currentPosts.map((post, index) => { 
            const postUrl = `/@${post.author}/${post.permlink}`;
            const view = views.find(v => v.url === postUrl);
            const viewsCount = view ? view.count : 0; 
            const plan = userPlans.find(u => u.username === post.author);  
            let isPlus = plan?.plan_type?.includes("plus") || false;
            let postData = {
                ...post, 
                views:viewsCount
            }; 
            return (
                <div
                key={`${post.id}-${index}`}
                className="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 p-2"
                ref={(node) => {
                    if (index === currentPosts.length - 1) {
                        lastPostElementRef(node);
                    }
                }}
                >
                <PostVideoItem post={postData} isPlus={isPlus}  />
                </div>
            );
        });
        return section;
    }
    return (
        <div className="p-3">
            <h2>Results for: "{query}"</h2> 
            <div className="menu-tabs">
                <button className={`tab-button ${activeTab === 'user' ? 'active' : ''}`} onClick={() => setActiveTab('user')} title="Users">
                    <i className="fas fa-users" /> <span className="d-none d-md-inline ml-1">Users</span>
                </button>
                <button className={`tab-button ${activeTab === 'video' ? 'active' : ''}`} onClick={() => setActiveTab('video')} title="Videos">
                    <i className="fas fa-play" /> <span className="d-none d-md-inline ml-1">Videos</span>
                </button> 
            </div>

            {loading && activeTab === "user" && (
                <>
                    {[1, 2, 3].map(i => (
                        <div className="channel-card" key={i}>
                            <div className="channel-info-preview">
                                <Skeleton circle={true} height={80} width={80} className="channel-info-image" />
                                <div className="channel-info-details" style={{flex: 1, marginLeft: '15px'}}>
                                    <Skeleton width={150} height={20} className="mb-2" />
                                    <Skeleton width={100} height={15} />
                                </div>
                            </div>
                            <Skeleton width={80} height={35} />
                        </div>
                    ))}
                </>
            )}

            {activeTab === 'user' && !loading && accounts.map((account) => {
                let imageLink =  `https://steemitimages.com/u/${account.name}/avatar`; 

                let public_profile;
                try {
                    if (account.posting_json_metadata) {
                    public_profile = JSON.parse(account.posting_json_metadata);
                    } 
                } catch (error) {
                    console.log("While getting public profile", error); 
                    // onNewError(error); 
                }
                let publicName = account.name;
                try {
                    publicName = (public_profile && public_profile.profile.name) ?public_profile.profile.name : account.name;
                } catch (error) {
                    console.log("while getting public name");
                    
                }
                const plan = userPlans.find(u => u.username === account.name);  
                let isPlus = plan?.plan_type?.includes("plus") || false;
                return (
                    <div className="channel-card" key={account.name}>
                        <div className="channel-info-preview">
                        <img className="channel-info-image" src={imageLink} alt="User Avatar" />
                        <div className="channel-info-details">
                            <span className="channel-info-name"><Link to={`/u/${account.name}`} className='color-letters'>{publicName}</Link> {(isPlus) && (<div className="text-muted d-inline-block"  title='Verified Plus member.' style={{marginRight:"2px", cursor:"pointer"}}><VerifiedIcon size={30} className="color-speem" /> </div> )}</span>
                            <span className="channel-info-username"><Link to={`/u/${account.name}`} className='color-letters'>@{account.name} ({getReputation(account.reputation)})</Link></span> 
                            {/* <span className="channel-info-followers">{account.followers_count.follower_count || 0} follower{(account.followers_count.follower_count > 1)? 's':null}</span> */}
                        </div>
                        </div>
                        {!user && (
                        <> 
                            <button className="follow-button" onClick={toggleLoginModal}>Follow</button> 
                        </>
                        )} 
                        {(user && user != account.name) && (
                        <> 
                            {user && user !== account.name && (
                                <FollowButton author={account.name} onError={()=>{console.log("error"); }} />
                            )}

                        </>
                        )} 
                    
                    </div>
                );
            })}

            {activeTab === 'video' && (
                <div className="row p-0 m-0 w-100"> 
                    {(() => {
                        let section = renderPosts();
                        return section;
                    })()}
                    {loadingMore && <div className='col-12 text-center color-orange'>Loading more videos...</div>} 
                </div>
            )}
            <LoginModal
                isShowing={isOpenLoginModal}
                hide={toggleLoginModal}
            />
        </div>
        
    );
};

export default SearchResults;
